import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { Paginator, PaginatorState } from "primeng/paginator";

export type Kno2PageChangeEvent = PaginatorState;

@Component({
    selector: "kno2-paginator",
    imports: [Paginator],
    template: `
        <p-paginator
            [rows]="rows()"
            [totalRecords]="totalRecords()"
            (onPageChange)="pageChange.emit($event)" />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginatorComponent {
    public readonly rows = input<number>();
    public readonly totalRecords = input<number>();
    public readonly pageChange = output<Kno2PageChangeEvent>();
}
